import LoyaltyMultipleOffers from './loyalty-multiple-offers.vue';

export default LoyaltyMultipleOffers;
